import { z } from "zod";

// ─── GET /api/bank-transactions/incoming ─────────────────────────────────────

export const IncomingTransactionListQuerySchema = z
  .object({
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    search: z.string().max(200).optional(),
    match_status: z.enum(["matched", "unmatched"]).optional(),
    account_type: z.enum(["client", "operational"]).optional(),
  })
  .refine((d) => !d.from || !d.to || d.from <= d.to, {
    message: "`from` must be <= `to`",
  });
export type IncomingTransactionListQuery = z.infer<typeof IncomingTransactionListQuerySchema>;

export const IncomingTransactionItemSchema = z.object({
  id: z.string().uuid(),
  booking_date: z.string().date(),
  amount: z.string().regex(/^\d+\.\d{2}$/),
  account_type: z.enum(["client", "operational"]),
  counterparty: z.string().nullable(),
  description: z.string().nullable(),
  invoice_id: z.string().uuid().nullable(),
  invoice_number: z.string().nullable(),
  match_status: z.enum(["matched", "unmatched"]),
});
export type IncomingTransactionItem = z.infer<typeof IncomingTransactionItemSchema>;

export const IncomingTransactionListResponseSchema = z.object({
  transactions: z.array(IncomingTransactionItemSchema),
  total: z.number().int().min(0),
});
export type IncomingTransactionListResponse = z.infer<typeof IncomingTransactionListResponseSchema>;
